import { useState, useEffect } from "react";
import { Film } from "lucide-react";

export default function SafeThumb({ src }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return (
      <span className="grid h-full w-full place-items-center bg-ink/5 text-ink/30">
        <Film size={16} />
      </span>
    );
  }
  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
      className="h-full w-full object-cover"
    />
  );
}